import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  selectSignUpInvite,
  selectSignUpUser,
  selectSignUpType,
  selectSignUpProperty,
  selectAuthenticated,
} from '../../../redux/auth/selectors';

import { withRouter } from 'react-router-dom';
import {
  SELECT,
  INSTRUCTIONS,
  TYPE_CONTACT_INVITE,
  PROPERTY_PHOTO,
  USER_PHOTO,
  HOUSEHOLD_REQUEST,
  HOUSEHOLD_SELECT,
  INFO,
  PROPERTY_SELECT,
  PROPERTY_RETRY,
  TYPE_GENERIC,
  CONFIRM,
  SIGNIN,
  TYPE_GENERIC_HOUSEHOLD_INVITE,
  TYPE_HOUSEHOLD_INVITE,
  TYPE_GENERIC_INVITE,
  TYPE_DOOR_KNOCKING,
} from '../config';
import routes from '../../../constants/routes';

class RedirectHelper extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.shape({
      replace: PropTypes.func.isRequired,
    }).isRequired,
    inviteData: PropTypes.object,
    userData: PropTypes.object,
    propertyData: PropTypes.object,
    type: PropTypes.string,
    prevRoute: PropTypes.string.isRequired,
    property_conflict: PropTypes.bool,
    authenticated: PropTypes.bool.isRequired,
    openTOSModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    inviteData: null,
    userData: null,
    propertyData: null,
    type: '',
    property_conflict: false,
  };

  componentWillMount() {
    this.redirect();
  }

  shouldComponentUpdate(nextProps) {
    const { location } = this.props;
    if (nextProps.location.pathname !== location.pathname) {
      return true;
    }
    return false;
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (prevProps.location.pathname !== location.pathname) {
      this.redirect();
    }
  }

  redirect = () => {
    const {
      location,
      inviteData,
      userData,
      propertyData,
      property_conflict,
      type,
      prevRoute,
      history,
      authenticated,
      openTOSModal,
    } = this.props;
    const { pathname } = location;
    if (pathname !== CONFIRM && inviteData && authenticated) {
      if (inviteData.invitation_type === TYPE_DOOR_KNOCKING) {
        // skip redirecting to confirm ponel for door-knocking signups
        return;
      }

      return history.replace(CONFIRM);
    }

    if (
      (pathname === PROPERTY_PHOTO ||
        pathname === PROPERTY_RETRY ||
        pathname === CONFIRM ||
        pathname === PROPERTY_SELECT ||
        pathname === USER_PHOTO ||
        pathname === HOUSEHOLD_REQUEST ||
        pathname === HOUSEHOLD_SELECT) &&
      !userData &&
      !inviteData
    ) {
      return history.replace(SELECT);
    }

    if (userData) {
      if (
        pathname === INFO ||
        pathname === INSTRUCTIONS ||
        pathname === SELECT
      ) {
        if (
          prevRoute !== INFO &&
          prevRoute !== INSTRUCTIONS &&
          prevRoute !== SELECT &&
          prevRoute !== SIGNIN &&
          prevRoute.includes(routes.SIGNUP)
        ) {
          return history.replace(prevRoute);
        }
        if (propertyData && !property_conflict) {
          return openTOSModal();
        }
        if (type === TYPE_GENERIC) {
          return history.replace(HOUSEHOLD_SELECT);
        }
      }

      if (
        pathname === PROPERTY_PHOTO &&
        (type === TYPE_GENERIC_HOUSEHOLD_INVITE ||
          type === TYPE_HOUSEHOLD_INVITE)
      ) {
        return openTOSModal();
      }

      if (
        propertyData &&
        !property_conflict &&
        (pathname === PROPERTY_SELECT ||
          pathname === PROPERTY_RETRY ||
          pathname === HOUSEHOLD_REQUEST ||
          pathname === HOUSEHOLD_SELECT)
      ) {
        return openTOSModal();
      }

      if (property_conflict && type === TYPE_GENERIC) {
        if (pathname === PROPERTY_PHOTO || pathname === USER_PHOTO) {
          return history.replace(HOUSEHOLD_SELECT);
        }
      }
    }

    if (pathname === SELECT && inviteData) {
      return history.replace(
        type === TYPE_CONTACT_INVITE || type === TYPE_GENERIC_INVITE
          ? INFO
          : INSTRUCTIONS,
      );
    }

    if (
      pathname !== SELECT &&
      pathname !== SIGNIN &&
      pathname !== INSTRUCTIONS &&
      !type
    ) {
      return history.replace(SELECT);
    }
  };

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  inviteData: selectSignUpInvite(state),
  userData: selectSignUpUser(state),
  propertyData: selectSignUpProperty(state),
  type: selectSignUpType(state),
  prevRoute: state.auth.prevRoute,
  property_conflict: state.auth.property_conflict,
  authenticated: selectAuthenticated(state),
});

export default withRouter(connect(mapStateToProps)(RedirectHelper));
